export const SET_CHANGE_LOG_DATA_LIMIT_REACHED = 'CHANGE_LOG_DATA_LIMIT_REACHED:SET';
export const SET_CHANGE_LOG_IS_ACTIVE = 'CHANGE_LOG_IS_ACTIVE:SET';
export const SET_CHANGE_LOG_FILTERS = 'CHANGE_LOG_FILTERS:SET';
export const UPDATE_CHANGE_LOG_FILTER = 'CHANGE_LOG_FILTERS:UPDATE';
export const UPDATE_CHANGE_LOG_SEARCH_BY = 'CHANGE_LOG_SEARCH_BY:UPDATE';
export const RESET_CHANGE_LOG_FILTER = 'CHANGE_LOG_FILTERS:RESET';
export const LOAD_CHANGE_LOG_DATA = 'CHANGE_LOG_DATA:LOAD';
export const INITIALIZE_CHANGE_LOG_QUICK_VIEW = 'CHANGE_LOG_QUICK_VIEW:INITIALIZE';
export const REFRESH_CHANGE_LOG_DATA = 'CHANGE_LOG_DATA:REFRESH';
